export const UPLOAD_CONSULTATION_MEDIA = (appointmentId, comment) => `
  mutation {
    uploadFile(
      input: {
        appointmentId: "${ appointmentId }",
        comment: "${ comment }",
        uploadingType: CONSULTATION_ATTACHMENT,
      }
    ) {
      metaDataId
      name
      mimeType
      encoding
      size
      downloadRoute
      comment
    }
  }
`;
